import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {RouterModule} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {MainPagesContainerComponent} from '../main-pages-container/main-pages-container.component';
import {environment} from "../../../../environments/environment";

@Component({
    selector: 'app-rules',
    templateUrl: './rules.component.html',
    styleUrls: ['../main.pages.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MainPagesContainerComponent,
        MatButtonModule,
        RouterModule,
        TranslatePipe
    ]
})
export class RulesComponent {
    protected domain = environment.canonicalDomain
}
